<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
export default {
  props: {
    type: {
      default: 'simple',
      type: String,
      validator: function (value) {
        return ['simple', 'advanced', 'advanced-online', 'signup', 'extended', 'anniversary'].indexOf(value) !== -1
      }
    }
  },
  provide () {
    const modules = {
      simple: 'form',
      signup: 'signupform',
      advanced: 'advancedform',
      extended: 'extendedform',
      anniversary: 'anniversary',
      'advanced-online': 'advancedonlineform'
    }

    const module = modules[this.type]
    const errors = this.$store.state[module][module].errors

    errors.onRecord((errors, error, value) => {
      this.$nextTick(() => {
        const errorElement = document.querySelector('.input-wrapper.error')
        if (errorElement) {
          const domRect = errorElement.getBoundingClientRect()
          window.scrollTo(
            domRect.left + document.documentElement.scrollLeft - 100,
            domRect.top + document.documentElement.scrollTop - 100
          )
        }
      })
    })
    return {
      errors
    }
  }
}
</script>
